import { GET, omsBaseUrlApi } from '@constants/generic-constants.js';
import NetworkManager from '../../services/network-service.js';
import PermissionsHelper from '../../auth/helper/PermissionHelper.js';
import { ACTION_INDEX, PERMISSION_KEY_CONSIGNMENT } from '../../constants/permission-constants.js';
import { ACCESS_DENIED } from '../../constants/seller-center-paths.js';
import { redirectToPath } from '../../utils/utils.js';

export const shipmentsListingApi = (params = '') => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_CONSIGNMENT, ACTION_INDEX)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    let url = `${omsBaseUrlApi}/consignments${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const printShippingLabelApi = (id, responseType) => {
  return new Promise((resolve, reject) => {
    let url = `${omsBaseUrlApi}/consignments/${id}/print_shipping_label`;
    NetworkManager.performRequest(url, null, GET, undefined, responseType)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
